import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { affiliateRoute } from '.'

const MemberList = lazyRouteComponent(
  () => import('../../../pages/profile/affiliate/member-list'),
)

export const memberListRoute = createRoute({
  getParentRoute: () => affiliateRoute,
  path: 'member-list',
  component: MemberList,
})
